import PropTypes from 'prop-types';
import { truncate } from 'lodash';
import { Tooltip, Typography } from '@mui/material';

export const TitleTooltip = ({ title, titleLength, children, ...typographyProps }) => {
  return (
    <Tooltip disableHoverListener={title?.length < titleLength} title={title}>
      {children || <Typography {...typographyProps}>{truncate(title, { length: titleLength })}</Typography>}
    </Tooltip>
  );
};

TitleTooltip.propTypes = {
  title: PropTypes.string.isRequired,
  titleLength: PropTypes.number.isRequired,
  children: PropTypes.node,
};
